import { JSX, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { Button, Typography } from "@platform/design-system";

import { SelectFilter, type Option } from "./SelectFilter";

export type MultipleLocModalProps = {
  isOpen: boolean;
  locs: Option[];
  onClose: VoidFunction;
  onConfirm: (selectedLocs: string[]) => void;
};

export default function MultipleLocModal({
  isOpen,
  locs,
  onClose,
  onConfirm,
}: MultipleLocModalProps): JSX.Element {
  const [selectedLocs, setSelectedLocs] = useState<Option[]>([]);

  const options = locs;

  const handleClose = (): void => {
    setSelectedLocs([]);
    onClose();
  };

  const handleConfirm = (): void => {
    onConfirm(selectedLocs.map((opt) => opt.value));
    setSelectedLocs([]);
  };

  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>Remove Document</DialogTitle>
      <DialogContent>
        <DialogContentText>
          This document spans multiple lines of coverage. Removing a file will
          delete all plans under the selected line(s) of coverage.
        </DialogContentText>
        <Typography variant="body-medium" sx={{ mt: 2, mb: 1 }}>
          Lines of Coverage
        </Typography>
        <SelectFilter
          label="Lines of Coverage"
          placeholder="Select a line of coverage"
          options={options}
          value={selectedLocs}
          onChange={setSelectedLocs}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="tertiary">
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          variant="primary"
          disabled={selectedLocs.length === 0}
        >
          Remove
        </Button>
      </DialogActions>
    </Dialog>
  );
}
